export class EventAspect {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    aspect;
}
